import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, ExternalLinkIcon } from 'lucide-react';
const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/YkZ8cAkm4wWJcYB3A';
interface FooterProps {
  dark?: boolean;
}
export function Footer({
  dark = false
}: FooterProps) {
  return <footer className={`w-full text-[#F2EDE4] py-12 px-4 mt-auto ${dark ? 'bg-[#0E0C0B] border-t border-[#F5EDE3]/10' : 'bg-[#3A3A2E]'}`} data-id="element-504" data-mp="36p6dt1d5n2d9">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 text-center md:text-left" data-id="element-505" data-mp="3ufjww2drhqvp">
        <div className="space-y-2" data-id="element-506" data-mp="36d44znhyxod">
          <h3 className="font-serif text-xl text-[#7C8062]" data-id="element-507" data-mp="3lf582t1l9tng">
            Top Notch Bakery
          </h3>
          <p className="text-sm opacity-80" data-id="element-508" data-mp="3qcnjqr6zqmz5">Est. 2021</p>
        </div>

        <div className="flex flex-col gap-3 text-sm opacity-90" data-id="element-509" data-mp="29z6x2jmuoxjl">
          <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-510" data-mp="29xvqyd5xndpb">
            <MapPinIcon className="h-4 w-4 text-[#7C8062]" data-id="element-511" data-mp="3gaz3l7v1stm7" />
            <span data-id="element-512" data-mp="3gck0v58qyqnr">Klostergatan 7, Växjö</span>
          </a>
          <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-513" data-mp="3v8rfzr5at1w6">
            <ClockIcon className="h-4 w-4 text-[#7C8062]" data-id="element-514" data-mp="80nrednpyga8" />
            <span data-id="element-515" data-mp="335rtdvlddew">Se öppettider på Google Maps</span>
            <ExternalLinkIcon className="h-3 w-3 opacity-50" data-id="element-516" data-mp="hstsccvy881k" />
          </a>
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-517" data-mp="huwh6tld7v4p">
            <PhoneIcon className="h-4 w-4 text-[#7C8062]" data-id="element-518" data-mp="cuil89x1gbn1" />
            <span data-id="element-519" data-mp="qsqdi4j4qorv">0470-52 36 03</span>
          </div>
          <a href="mailto:info@topnotchbakery.se" className="flex items-center justify-center md:justify-start gap-2 hover:text-[#7C8062] transition-colors" data-id="element-520" data-mp="qrfaw81f7n2c">
            <MailIcon className="h-4 w-4 text-[#7C8062]" data-id="element-521" data-mp="tt07un1zcgow" />
            <span data-id="element-522" data-mp="yv94bte2a0vr">info@topnotchbakery.se</span>
          </a>
        </div>

        <div className="text-xs opacity-50" data-id="element-523" data-mp="13tkc7yksq1bc">
          &copy; {new Date().getFullYear()} Top Notch Bakery.
        </div>
      </div>
    </footer>;
}